module.exports = __webpack_public_path__ + "static/up-and-running-1x-9c4ae2888d7ad72ead2dbcdcaf70d2b6.png";